import React from 'react';
import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'en', label: 'EN' },
  { code: 'fr', label: 'FR' },
  { code: 'de', label: 'DE' },
];

function LanguageSwitcher({ className = '' }) {
  const { i18n, t } = useTranslation();
  const currentLang = i18n.resolvedLanguage || i18n.language || 'en';

  return (
    <div
      role="group"
      aria-label={t('languageSwitcher.label')}
      className={`inline-flex items-center rounded-lg border border-white/20 overflow-hidden ${className}`}
    >
      {LANGUAGES.map(({ code, label }) => (
        <button
          key={code}
          type="button"
          onClick={() => i18n.changeLanguage(code)}
          aria-pressed={currentLang === code}
          className={`px-2.5 py-1.5 text-xs font-bold transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-[#FFD82D] ${
            currentLang === code
              ? 'bg-[#FFD82D] text-[#162E3B]'
              : 'text-white hover:bg-white/10'
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default LanguageSwitcher;
